import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/typeinvoice";
var post = "/typeinvoice";
export const actGetDataTypeInvoice = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_TYPEINVOICE_TYPEINVOICE" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEINVOICE_TYPEINVOICE",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({
          type: "ERROR_TYPEINVOICE_TYPEINVOICE",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEINVOICE_TYPEINVOICE",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataTypeInvoice = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_TYPEINVOICE_TYPEINVOICE" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type invoice has been created");
          dispatch(
            __openModal({ modal: "MODAL_ADD_TYPEINVOICE", open: false })
          );
          return dispatch(actGetDataTypeInvoice());
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_TYPEINVOICE_TYPEINVOICE",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEINVOICE_TYPEINVOICE",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataTypeInvoice = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_TYPEINVOICE_TYPEINVOICE" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type invoice has been updated");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_TYPEINVOICE", open: false })
          );
          return dispatch(actGetDataTypeInvoice());
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_TYPEINVOICE_TYPEINVOICE",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEINVOICE_TYPEINVOICE",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataTypeInvoice = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_TYPEINVOICE_TYPEINVOICE" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEINVOICE_TYPEINVOICE",
            message: "Success get data",
          });
        }
        return dispatch({
          type: "ERROR_TYPEINVOICE_TYPEINVOICE",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEINVOICE_TYPEINVOICE",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataTypeInvoice = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_TYPEINVOICE_TYPEINVOICE" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type invoice has been deleted");
          return dispatch(actGetDataTypeInvoice());
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_TYPEINVOICE_TYPEINVOICE",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEINVOICE_TYPEINVOICE",
          message: "Network error..",
        });
      });
  };
};
